/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "de29965d63b219722478fb1a122b7244c25b7fec";
